import { reactive } from 'vue'
import type { FormRules } from 'element-plus'

export const rules = reactive<FormRules>({
    email: [
        {
            required: true,
            message: 'Kötelező mező!',
            trigger: ['blur', 'change']
        },
        {
            pattern: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/,
            message: 'Hiba az email címben!',
            trigger: ['blur', 'change']
        }
    ],
    firstName: [
        {
            required: true,
            message: 'Kötelező mező!',
            trigger: ['blur', 'change']
        }
    ],
    lastName: [
        {
            required: true,
            message: 'Kötelező mező!',
            trigger: ['blur', 'change']
        }
    ]
})
